import { nameScreenDynamic } from '../../utils/variables';

export function loadSelectoptionList(answers) {
    let list = document.querySelector(`${nameScreenDynamic} .list-question`);
    if (!list) return;
    const options = Array.isArray(answers) ? answers : [];
    const optionValues = options.map((o) => (typeof o === 'string' ? o : (o?.value ?? o?.label ?? String(o))));

    let optionList = ``;
    for (const i of optionValues) {
        optionList = optionList.concat(`
        <div class="option" data-option="${i}">
            <span class="option__name">${i}</span>
            <span class="option__checkbox" data-option="${i}">
                <i class="option__icon-check ri-check-line"></i>
            </span>
        </div>
        `);
    }

    list.insertAdjacentHTML('beforeend', optionList);
}

export function selectOption(value, isMultiSelect = false) {
    if (isMultiSelect) {
        const checkbox = document.querySelector(
            `${nameScreenDynamic} .option__checkbox[data-option="${CSS.escape(value)}"]`
        );
        checkbox.classList.toggle('is-selected');

        const hasSelectedOptions = document.querySelectorAll(
            `${nameScreenDynamic} .option__checkbox.is-selected`
        ).length > 0;

        const continueBtn = document.querySelector(`${nameScreenDynamic} .selectContinue__btn`);
        if (hasSelectedOptions) {
            continueBtn.classList.remove('disabled');
        } else {
            continueBtn.classList.add('disabled');
        }
    } else {
        removeAllSelectedOption();
        document
            .querySelector(
                `${nameScreenDynamic} .option__checkbox[data-option="${CSS.escape(value)}"]`
            )
            .classList.add('is-selected');
        document
            .querySelector(`${nameScreenDynamic} .selectContinue__btn`)
            .classList.remove('disabled');
    }
}

export function removeAllSelectedOption() {
    document
        .querySelectorAll(`${nameScreenDynamic} .option__checkbox`)
        .forEach((i) => i.classList.remove('is-selected'));

    document
        .querySelector(`${nameScreenDynamic} .selectContinue__btn`)
        .classList.add('disabled');
}
